import React from "react"
import { FormsList } from "../../components/ListView"
import { CheckBox, Input, Label, SelectInput } from "../../components/Form"
import { BulletTabs } from "../../components/BulletTabs"
import { Button } from "../../components/Button"
import Accordion from "../../components/Accordion"
import { StepFields } from "../../components/StepFields"
import { LoadingWithLabel } from "../../components/Loading"
import "./styles.scss"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"

const FormAddModal = ({
  formAddModal,
  formStepsAddModal,
  handleCloseFormStepsAddModal,
  handleCloseFormAddModal,
  selectedForm,
  handleSelectedForm,
  setAllSteps,
  allSteps,
  handleSelectedSteps,
  handleSelectedGroups,
  selectedGroups,
  groupForms,
  loadingSelectedForm,
  loadingFormAndSteps,
  indicatorTabsOptions,
  handleSelectedAllGroups,
  handleAddSteps,
  handleChangeFilter,
  setSelectedSteps
}) => {

  const AccordionHeader = ({ title, id, selectedGroups }) => {
    return (
      <>
        <div className="add-form-accordion__header">
          <div className="checkbox">
            <CheckBox
              onChange={handleSelectedGroups}
              value={id}
              checked={selectedGroups?.some((val) => val === id)}
            />
          </div>
          <span>{title}</span>
        </div>
      </>
    )
  }

  return (
    <ModalPanel modalIsOpen={formAddModal} width={700}>
      <ModalHeader title="Iniciar Formulário" closeModal={handleCloseFormAddModal} />
      <ModalBody bodyClassName="form-steps-modal-body">
        {!formStepsAddModal ? (
          <>
            <header className="form-add-modal-header">Selecione um formulário</header>
            {loadingSelectedForm ? (
              <>
                <LoadingWithLabel labelLoading="Buscando Formulários..." colorSpinner="primary" />
              </>
            ) : (
              <>
                <Input
                  hasFocus={false}
                  placeholder="Digite aqui o nome do formulário"
                  onChange={handleChangeFilter}
                />
                <FormsList data={selectedForm} handleClick={handleSelectedForm} isModal />
              </>
            )}
          </>
        ) : (
          <>
            {loadingFormAndSteps ? (
              <div className="form-steps-loading">
                <LoadingWithLabel labelLoading="Buscando etapas..." colorSpinner="primary" />
              </div>
            ) : (
              <>
                <header className="form-add-modal-header">
                  <div className="form-add-modal-header-check steps">
                    <CheckBox checked={allSteps} onChange={() => setAllSteps(!allSteps)} />
                    Selecionar todas as etapas
                  </div>
                </header>
                <div className="form-steps-tabs">
                  {indicatorTabsOptions && indicatorTabsOptions.length > 0 && (
                    <BulletTabs
                      onSelect={handleSelectedSteps}
                      options={indicatorTabsOptions}
                      setSelectedTabs={setSelectedSteps}
                      allowMultiple={allSteps}
                    />
                  )}
                </div>
                <div className="form-grp">
                  <header className="form-add-modal-header">
                    Selecione a(s) subetapa(s) que deseja adicionar ao formulário
                    <div className="form-add-modal-header-check groups">
                      <CheckBox
                        disabled={groupForms?.length === 0}
                        onChange={handleSelectedAllGroups}
                        checked={
                          groupForms?.length > 0 && selectedGroups?.length === groupForms?.length
                        }
                      />
                      Selecionar todas as subetapas
                    </div>
                  </header>
                  <div className="form-groups-accordion">
                    {groupForms &&
                      groupForms.map((groups, index) => {
                        return (
                          <Accordion
                            key={index}
                            index={index}
                            id={Math.random()}
                            header={
                              <AccordionHeader
                                title={groups?.title}
                                id={groups?.id}
                                selectedGroups={selectedGroups}
                              />
                            }>
                            <StepFields fields={groups?.questions || []} />
                          </Accordion>
                        )
                      })}
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <div className="form-add-modal-footer">
          <Button
            isDisabled={loadingSelectedForm}
            variant="ghost"
            label={formStepsAddModal ? "Voltar" : "Cancelar"}
            handleClick={
              formStepsAddModal
                ? () => handleCloseFormStepsAddModal()
                : () => handleCloseFormAddModal()
            }
          />
          <Button
            label="Adicionar"
            isDisabled={loadingSelectedForm || !selectedGroups?.length}
            handleClick={handleAddSteps}
          />
        </div>
      </ModalFooter>
    </ModalPanel>
  )
}

const FormDetailsScreen = ({
  mainCardStatus,
  handleClickItem,
  handleSelectedForm,
  showForm,
  selectedForm,
  loadingSelectedForm,
  loadingFormAndSteps,
  setFormAddModal,
  formAddModal,
  formStepsAddModal,
  handleCloseFormStepsAddModal,
  handleCloseFormAddModal,
  setAllSteps,
  allSteps,
  handleSelectedSteps,
  handleSelectedGroups,
  selectedGroups,
  handleSelectedAllGroups,
  groupForms,
  indicatorTabsOptions,
  options,
  handleAddSteps,
  initialFormList,
  handleOpenForm,
  handleChangeFilter,
  setSelectedSteps
}) => {

  return (
    <div className="form-assistance-screen">
      {mainCardStatus?.header && (
        <>
          <header className="form-assistance-screen-header">
            <h4>Formulários complementares iniciados</h4>
            <Button handleClick={() => setFormAddModal(true)} label="Iniciar formulário" />
          </header>
          <div className="form-list">
            <FormsList data={initialFormList} handleClick={handleOpenForm} />
          </div>
        </>
      )}
      {showForm && !mainCardStatus?.header && (
        <div className="form-list-steps">
          <div className="step-questions">
            <header className="step-questions-header">
              <h1>Etapas do formulário</h1>
              <div className="select">
                <Label label="Perguntas" />
                <SelectInput />
              </div>
            </header>
            <div className="step-questions-content">
              <div className="step-questions-content-tabs">
                <BulletTabs options={options} />
              </div>
              <div className="step-questions-content-forms">
                <div className="form-field">
                  <Label label="Perguntas" />
                  <div className="field-action">
                    <Input hasFocus={false} />
                    <div className="steps__item-field-actions-buttons" onClick={() => { }}>
                      <i
                        title="Adicionar"
                        className="fi fi-rr-add"
                        style={{ color: "#99AA99" }}></i>
                    </div>
                  </div>
                </div>
                <div className="form-field">
                  <Label label="Perguntas" />
                  <div className="field-action">
                    <SelectInput />
                    <div className="steps__item-field-actions-buttons" onClick={() => { }}>
                      <i
                        title="Adicionar"
                        className="fi fi-rr-add"
                        style={{ color: "#99AA99" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {formAddModal && (
        <FormAddModal
          {...{
            formAddModal,
            formStepsAddModal,
            handleCloseFormStepsAddModal,
            handleCloseFormAddModal,
            selectedForm,
            handleSelectedForm,
            setAllSteps,
            allSteps,
            handleSelectedSteps,
            handleSelectedGroups,
            selectedGroups,
            groupForms,
            loadingSelectedForm,
            loadingFormAndSteps,
            indicatorTabsOptions,
            handleSelectedAllGroups,
            handleAddSteps,
            handleChangeFilter,
            setSelectedSteps
          }}
        />
      )}
    </div>
  )
}

export default FormDetailsScreen
